module.exports = __webpack_public_path__ + "static/media/logo-vertical.f9309115.png";